import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  isLoading = new Subject<boolean>();
  private counter: number = 0;

  show(): void {
    this.counter++;
    this.isLoading.next(this.counter > 0);
  }

  hide(): void {
    this.counter--;
    setTimeout(() => {
      this.isLoading.next(this.counter > 0);
    }, 1000);
  }
}
